import { Navigate, Route, Routes } from 'react-router-dom';
import { WithdrawList } from '../WithdrawList/WithdrawList';
import { Login } from '../Login/Login';
import { LoginVerify } from '../LoginVerify/LoginVerify';
import { ProtectedLayout } from '../Shared/ProtectedLayout/ProtectedLayout';
import { WithdrawRequest } from '../WithdrawRequest/WithdrawRequest';
import { ChallengesList } from '../ChallengesList/ChallengesList';
import { TournamentsList } from '../TournamentsList/TournamentsList';
import { TournamentDetail } from '../TournamentDetail/TournamentDetail';
import { CreateTournament } from '../CreateTournament/CreateTournament';
import { EditTournament } from '../EditTournament/EditTournament';
import { ChallengeDetail } from '../ChallengeDetail/ChallengeDetail';
import { EditChallenge } from '../ChallengeDetail/EditChallenge';

const Router = () => (
    <Routes>
        <Route path={'/login'} element={<Login />} />
        <Route path={'/login/verify'} element={<LoginVerify />} />

        <Route path="/" element={<ProtectedLayout />}>
            <Route path={'/'} element={<WithdrawList />} />
            <Route path={'/challenges'} element={<ChallengesList />} />
            <Route path={'/withdraw-request/:id'} element={<WithdrawRequest />} />
            <Route path={'/tournaments'} element={<TournamentsList />} />
            <Route path={'/tournaments/create'} element={<CreateTournament />} />
            <Route path={'/tournaments/:id/edit'} element={<EditTournament />} />
            <Route path={'/tournaments/:id/challenges/:challengeId/edit'} element={<EditChallenge />} />
            <Route path={'/tournaments/:id/challenges/:challengeId'} element={<ChallengeDetail />} />
            <Route path={'/tournaments/:id'} element={<TournamentDetail />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
);

export default Router;
